module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./RecommendListView.js"));
	}, "RecommendListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RecommendListView!./src/pages/Promote/MaterialCenter/RecommendList/RecommendListView.js
// module id = 2056
// module chunks = 367